<template>
  <div>
    <div class="skeleton" :style="{ height: height - 12 + 'px' }">
      <div class="bar-holder" :style="{ height: height - 58 + 'px' }">
        <div v-for="height in bars" 
        class="bar"
        :key="height" 
        :style="{ height: String(height) + '%' }"></div>
      </div>
      <div class="bottom-axis"></div>
      <div class ="shimmer"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    height: { type: Number, default: 300 }
  },
  data () {
    return {
      bars: [
        33,
        100,
        72,
        39,
        90,
        79,
        91,
        65,
        13,
        12
      ]
    }
  }
}
</script>

<style scoped>
.bar {
  background-color: #F7F8F9;
  border-radius: 5px;
  width: 10%;
  margin-right: 15px;
}
.bar-holder {
  display: flex;
  align-items: flex-end;
  margin-right: -15px;
}
.bottom-axis {
  background-color: #F7F8F9;
  width: 100%;
  height: 20px;
  margin-top: 26px;
}
.skeleton {
  position: relative;
  overflow: hidden;
  margin-top: 6px;
  margin-bottom: 6px;
}
.shimmer {
  background-image: linear-gradient(90deg, rgba(255,255,255,0) 0px, #FFF 40px, rgba(255,255,255,0) 80px);
  background-size: 80px 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 80px;
  animation: shine-lines 2s infinite ease-in-out;
}

@keyframes shine-lines {
  0% {
    left: -80px;
  }
  100% {
    left: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/reports/components/graphs/GraphSkeleton.vue